import { storageTypes } from "./storageTypes";

const initialState = {
  uploadData: {},
  downloadData: {},
  loading: false,
  crudLoading: false,
};

const fileStorage = (state = initialState, action) => {
  switch (action.type) {
    //upload
    case storageTypes.UPLOAD_FILE_START:
      return {
        ...state,
        crudLoading: true,
      };
    case storageTypes.UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        uploadData: action.payload,
      };
    case storageTypes.UPLOAD_FILE_FAILED:
      return {
        ...state,
        uploadData: action.payload,
        crudLoading: false,
      };
    case storageTypes.UPLOAD_FILE_END:
      return {
        ...state,
        crudLoading: false,
      };

    // download
    case storageTypes.DOWNLOAD_FILE_START:
      return {
        ...state,
        loading: true,
      };
    case storageTypes.DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        downloadData: action.payload,
      };
    case storageTypes.DOWNLOAD_FILE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case storageTypes.DOWNLOAD_FILE_END:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default fileStorage;
